<div *ngIf="dialogConfig && dialogConfig.data.url" class="col-sm-12 coldx">	
    <iframe [src]="dialogConfig.data.url | sanitizer"></iframe>
</div>
